<template>
  <div class="x431mr_wrapper">
    <v-header :status="true" />
    <img src="../assets/img2/banner2_2x.png" />
    <div class="middle">
      <div><img src="../assets/img2/aidtools_produce_txt.png" /></div>
      <a id="normal"
        href="https://item.taobao.com/item.htm?spm=a1z10.1-c-s.w5003-23287632624.4.22731c810Kl5si&ft=t&id=630943989133&scene=taobao_shop"
        ><img  src="../assets/img2/x431_2.jpg"
      /></a>
      <a id="pro"
        href="https://item.taobao.com/item.htm?spm=a1z10.1-c-s.w5003-23287632624.5.22731c810Kl5si&ft=t&id=630943989133&scene=taobao_shop"
        ><img  src="../assets/img2/x431_3.jpg"
      /></a>
      <a id="pro2"
        href="https://item.taobao.com/item.htm?spm=a1z10.1-c-s.w5003-23287632624.6.4d891c810XpjQg&ft=t&id=630943989133&scene=taobao_shop"
        ><img  src="../assets/img2/x431_4.jpg"
      /></a>
    </div>
  </div>
</template>
<script>
import VHeader from "../components/Header.vue";
export default {
  name: "X431mr",
  components: { VHeader },
  mounted() {
    const that = this;
    if (document.getElementById(that.$route.query.hashId)) {
      document.getElementById(that.$route.query.hashId).scrollIntoView({block:'center'});
      that.$forceUpdate();
    }
    setTimeout(() => {
      if (document.getElementById(that.$route.query.hashId)) {
        document.getElementById(that.$route.query.hashId).scrollIntoView({block:'center'});
        that.$forceUpdate();
      }
    }, 600);
  },
};
</script>
<style lang="less" scoped>
div.x431mr_wrapper {
  position: relative;
  min-width: 1420px;
  width: 100%;
  padding-bottom: 150px;
  background-color: #f4f9fc;
  > img {
    width: 100%;
    display: block;
  }
  > div.middle {
    position: relative;
    width: 1402px;
    margin: 0 auto;
    margin-top: 150px;
    > div:first-child {
         margin-bottom: 20px;
      div {
         margin-top: 80px;
      }
      > img {
        width: 328px;
        display: block;
        margin: 0 auto;
      }
    }
    >a{
      margin: 0 auto;
      >img{
      margin-top: 80px;
      width: 1402px;
      }
    }
    > img {
      width: 100%;
      display: block;
      cursor: pointer;
      margin-top: 60px;
    }
  }
}
</style>
